import { useMemo } from 'react';
import { connect } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';

const columns = [
    { field: 'scan_date',        headerName: 'Date',          width: 110 },
    { field: 'dc_name',          headerName: 'DC',            width: 140 },
    { field: 'door_name',        headerName: 'Door',          width: 120 },
    { field: 'transaction_time', headerName: 'Time',          width: 100 },
    { field: 'rfid',             headerName: 'RFID (EPC)',    width: 180 },
    { field: 'sscc_local_route', headerName: 'Route',         width: 100 },
    { field: 'stop_number',      headerName: 'Stop Number',   width: 130, type: 'number' },
    { field: 'pallet_id',        headerName: 'Pallet ID',     width: 150 },
    { field: 'planned_door',     headerName: 'Planned Door',  width: 130 },
    { field: 'movement_type',    headerName: 'Movement Type', width: 130 }
];

const DoorDetailsGridPanel = ({ allDoorDetailsData, filters }) => {

    // Group rows by door_name, applying door filter if set
    const doorGroups = useMemo(() => {
        if (!allDoorDetailsData || allDoorDetailsData.length === 0) return [];
        const selectedDoor = filters.door ? filters.door.id : null;
        const map = new Map();
        for (const row of allDoorDetailsData) {
            const door = row.door_name || '(Unknown)';
            if (selectedDoor && door !== selectedDoor) continue;
            if (!map.has(door)) map.set(door, []);
            map.get(door).push(row);
        }
        // Within each door: loads first (by time), returns at the bottom (by time)
        for (const [, rows] of map) {
            rows.sort((a, b) => {
                const aIsReturn = a.movement_type === 'Return' ? 1 : 0;
                const bIsReturn = b.movement_type === 'Return' ? 1 : 0;
                if (aIsReturn !== bIsReturn) return aIsReturn - bIsReturn;
                return (a.transaction_time || '').localeCompare(b.transaction_time || '');
            });
        }
        return Array.from(map.entries());
    }, [allDoorDetailsData]);

    if (!allDoorDetailsData || allDoorDetailsData.length === 0) {
        return (
            <div className="dashboardData-panel">
                <div className="duolift-device-detail-card" style={{ width: '100%' }}>
                    <div className="detail-card-header">
                        <h3 style={{ paddingTop: '10px' }}>DOOR-CENTRIC DETAILS</h3>
                    </div>
                    <div className="duolift-device-detail-card-body" style={{ padding: '20px' }}>
                        No data available.
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboardData-panel">
            <div className="duolift-device-detail-card" style={{ width: '100%' }}>
                <div className="detail-card-header">
                    <h3 style={{ paddingTop: '10px' }}>DOOR-CENTRIC DETAILS</h3>
                </div>
                <div className="duolift-device-detail-card-body">
                    {doorGroups.map(([doorName, rows]) => (
                        <div key={doorName} style={{ marginBottom: '24px' }}>
                            <div style={{
                                padding: '6px 12px',
                                backgroundColor: '#e8eaf6',
                                fontWeight: 'bold',
                                fontSize: '13px',
                                borderLeft: '4px solid #3f51b5'
                            }}>
                                {doorName}
                            </div>
                            <div style={{ height: '440px', width: '100%' }}>
                                <DataGrid
                                    rows={rows}
                                    columns={columns}
                                    pageSize={50}
                                    rowsPerPageOptions={[50]}
                                    disableSelectionOnClick
                                    getRowId={(row) => row.id}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    allDoorDetailsData: state.loadValidationDashboard.doorDetailsData,
    filters: state.loadValidationDashboard.filters
});

export default connect(mapStateToProps)(DoorDetailsGridPanel);
